import {
  Avatar,
  Button,
  Drawer,
  Form,
  List,
  Modal,
  Select,
  Skeleton,
  Space,
  Typography,
} from "antd";
import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
// import { NotificationInfo, UserInfo } from "../../../context";
import { DeleteOutlined, IdcardOutlined } from "@ant-design/icons";
import { NotificationInfo, UserInfo } from "../../../../context";
// import LOGO from "./../../../../assets/logo.png";

const AllowedRFIDCards = ({ open, close, selectedData }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const { userData } = useContext(UserInfo);
  const [initLoading, setInitLoading] = useState(true);
  const [addMerchantCard, setAddMerchantCard] = useState(false);
  const [merchantList, setMerchantList] = useState({
    data: [],
    ready: false,
  });
  const [merchantCards, setMerchantCards] = useState({
    data: [],
    ready: false,
  });
  const [tableData, setTableData] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const formRef = useRef(null);
  const [cardUIDValue, setCardUIDValue] = useState("");
  const [focused, setFocused] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  //   console.log("selectedData: ", selectedData);

  const getAllMerchantsRFIDCards = () => {
    var params = { merchant_id: selectedData.user_id };
    axios
      .get("user/admin/get/spec-store-cards/card-list", { params })
      .then((response) => {
        const data = response.data;
        setMerchantCards({ data, ready: true });
        setInitLoading(false);
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    axios
      .post("user/admin/create/merchant-cards", {
        rfid: cardUIDValue,
        merchant_id: selectedData.user_id,
      })
      .then((response) => {
        if (focused) {
          const data = response.data;
          console.log("DATA: ", data);
          if (data.result === "success") {
            // close();
            getAllMerchantsRFIDCards();
            // closeOriginDrawer();
            //   setUsername(data.username);
            // setVoidValidate(true);
            rerunNotif("success", "Card added successfully.");
          } else {
            // setVoidValidate(false);
            rerunNotif(
              "error",
              "Card is already added, Please try another one."
            );
          }
        }
        setIsSubmitting(false);
        setCardUIDValue("");
        setFocused(true);
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  //   const getMerchantList = () => {
  //     var params = { user_id: userData.data.id };
  //     axios
  //       .get("user/admin/merchant-list", {
  //         params,
  //       })
  //       .then((response) => {
  //         const data = response.data;
  //         setMerchantList({ data, ready: true });
  //       })
  //       .catch((error) => {
  //         console.log("ERROR: ", error);
  //       });
  //   };

  const onFocus = () => setFocused(true);

  const onBlur = (e) => {
    setFocused(false);
    if (!e.relatedTarget) {
      e.target.focus();
    }
  };

  useEffect(() => {
    getAllMerchantsRFIDCards();
    //   getMerchantList();
    setFocused(true);
  }, [selectedData]);

  //   const handleAddMerchant = (values) => {
  //     const formdata = new FormData();
  //     formdata.append("user_id", selectedData.user_id);
  //     for (const name in values) {
  //       formdata.append(name, values[name]);
  //     }
  //     setInitLoading(true);
  //     axios
  //       .post("user/admin/create/spec-store-admin/merchant-list", formdata)
  //       .then((response) => {
  //         const data = response.data;
  //         if (data === "success") {
  //           rerunNotif("success", "Added merchant successfully.");
  //           setTimeout(() => {
  //             setAddMerchantCard(false);
  //             getAllMerchantsConnection();
  //           }, 1000);
  //         }
  //         if (data === "merchant-exist") {
  //           rerunNotif("error", "Merchant already added.");
  //           setAddMerchantCard(false);
  //           setInitLoading(false);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log("Error: ", error);
  //       });
  //   };

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setOpenDelete(false);
      setConfirmLoading(false);
      handleRemoveStoreAdmin();
    }, 2000);
  };

  const handleRemoveStoreAdmin = () => {
    const formdata = new FormData();
    formdata.append("id", tableData.id);
    setInitLoading(true);
    axios
      .post("user/admin/remove/merchant-cards", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Removed RFID successfully.");
          setTimeout(() => {
            getAllMerchantsRFIDCards();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  return (
    <Drawer
      title="Card List"
      width={window.innerWidth > 500 ? 500 : window.innerWidth}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <Space>
          <Button
            type="primary"
            onClick={() => {
              setAddMerchantCard(true);
            }}
          >
            Add card
          </Button>
        </Space>
      }
    >
      {/* {console.log("tableData", tableData)} */}
      <List
        className="demo-loadmore-list"
        loading={initLoading}
        itemLayout="horizontal"
        //   loadMore={loadMore}
        dataSource={merchantCards.data}
        renderItem={(item, index) => (
          <List.Item
            actions={[
              <DeleteOutlined
                style={{ cursor: "pointer", color: "red", fontSize: 18 }}
                onClick={() => {
                  setTableData(item);
                  setOpenDelete(true);
                }}
              />,
            ]}
          >
            <Skeleton avatar title={false} loading={item.loading} active>
              <List.Item.Meta
                title={`${index + 1}. ${item.rfid_card}`}
                // description={
                //   <span style={{ textTransform: "lowercase" }}>
                //     {`${
                //       item.branchmerchant.business_street !== null
                //         ? `${item.branchmerchant.business_street}, `
                //         : ""
                //     }
                //     ${
                //       item.branchmerchant.business_barangay !== null
                //         ? `${item.branchmerchant.business_barangay}, `
                //         : ""
                //     }
                //     ${
                //       item.branchmerchant.business_city !== null
                //         ? `${item.branchmerchant.business_city}, `
                //         : ""
                //     }
                //     ${
                //       item.branchmerchant.business_province !== null
                //         ? `${item.branchmerchant.business_province}`
                //         : ""
                //     }
                //     `}
                //   </span>
                // }
              />
              {/* <div>content</div> */}
            </Skeleton>
          </List.Item>
        )}
      />

      <Modal
        title=""
        open={addMerchantCard}
        onCancel={() => setAddMerchantCard(false)}
        footer={null}
        width={350}
        centered
        getContainer={false}
      >
        <>
          <form
            onSubmit={handleSubmit}
            ref={formRef}
            style={{
              border: "1px solid red",
              opacity: 0,
            }}
          >
            <div style={{ display: "flex", flexDirection: "row" }}>
              <input
                type="text"
                autoFocus
                name="card_uid"
                id="card_uid"
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={(e) => setCardUIDValue(e.target.value)}
                value={cardUIDValue}
                autoComplete="off"
              />
              <button type="submit" disabled={isSubmitting}>
                SUBMIT
              </button>
            </div>
          </form>
          <div style={{ borderRadius: 20, marginBottom: 20 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <IdcardOutlined style={{ fontSize: "200px" }} />
              <Typography
                style={{
                  fontWeight: "bold",
                  color: "red",
                  fontStyle: "italic",
                }}
              >
                Please scan the RFID
              </Typography>
              <Typography style={{ fontSize: 18, fontWeight: "bold" }}>
                Scanning...
              </Typography>
            </div>
          </div>
          <div />
        </>
      </Modal>

      <Modal
        title="Are you sure to delete this RFID on the list?"
        open={openDelete}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setOpenDelete(false)}
        centered
        width={350}
      />
    </Drawer>
  );
};

export default AllowedRFIDCards;
